import config from 'constants/config'
import { getAgentHubAffiliationRules } from 'agentHub/selectors/agentHubSelectors'
import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'
import { useAppSelector } from 'hooks/reduxHooks'

function useIsCarHireSearchEnabled() {
  const agentHubAffiliationRules = useAppSelector((state) => getAgentHubAffiliationRules(state))
  const regionCode = useAppSelector((state) => state.geo.currentRegionCode)
  const isInAvailableCarHireRegion = config.CARHIRE_REGIONS.split(',').includes(regionCode)
  const canBookCarHire = !isAgentHubEnabled || agentHubAffiliationRules.canBookCarHire

  return config.CARHIRE_ENABLED &&
    config.CARHIRE_SEARCH_ENABLED &&
    isInAvailableCarHireRegion &&
    canBookCarHire
}

export default useIsCarHireSearchEnabled
